<template>
  <div style="width: 100%; height: 280px; margin: 0 auto;"/>
</template>

<script>
import echarts from 'echarts'
require('echarts/theme/macarons') // echarts theme
import resize from './resize'

var myColor = [
  '#30c7c9', '#b6a2de', '#59b1ef', '#ffb980',
  '#d87980', '#8c98b3', '#e5ce2c', '#97b552',
  '#996666', '#cc6699', '#339999', '#9966cc',
  '#6699cc', '#ff9933', '#cc6666', '#666699'
]
export default {
  mixins: [resize],
  props: {
    seriesData: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      chart: null,
      yAxisDatas: [],
      mySeriesData: [],
      legendData: []
    }
  },
  watch: {
    seriesData: {
      handler(newValue, oldValue) {
        this.seriesData = newValue // 把新值赋值给我们的属性数据
        this.initChart() // 刷新echarts图表
      },
      deep: true
    }
  },
  mounted() {
    this.$nextTick(() => {
    })
    setTimeout(() => {
      this.initChart()
    }, 50)
  },
  beforeDestroy() {
    if (!this.chart) {
      return
    }
    this.chart.dispose()
    this.chart = null
  },
  methods: {
    initChart() {
      var baifenbi = []
      var wancheng = []
      var zongjine = []
      var gs = []
      var dataArr = []
      // console.log(this.seriesData)
      this.seriesData.forEach(v => {
        if (v.name) { gs.push(v.name) } else { gs.push('') }
        wancheng.push(v.value)
        baifenbi.push(v.value / v.total)
        zongjine.push(v.total)
        dataArr.push(1)
      })
      this.chart = echarts.init(this.$el)
      var option = {
        backgroundColor: '#fff',
        grid: {
          left: '10px',
          right: '70px',
          bottom: '10px',
          top: '10px',
          containLabel: true
        },
        xAxis: [{
          show: false
        },
        {
          show: false
        }
        ],
        yAxis: {
          type: 'category',
          show: false
        },
        series: [
        // 背景色 完成、总金额
          {
            show: true,
            type: 'bar',
            barGap: '-100%',
            barWidth: '50%',
            barMaxWidth: 20,
            z: 1,
            itemStyle: {
              normal: {
                // barBorderRadius: 10,
                // color: function(params) {
                //   var num = myColor.length
                //   return myColor[params.dataIndex % num]
                // },
                color: 'rgb(230,235,245)'

                // opacity: 0.05
              }
            },
            label: {
              normal: {
                show: true,
                textStyle: {
                  color: '#000'
                },
                // position: [1000, '-10'],
                position: 'right',
                // position: 'right',
                formatter: function(data) {
                  // console.log(data)
                  return wancheng[data.dataIndex] + '/' + zongjine[data.dataIndex]
                }
              }
            },
            data: dataArr
          },
          // 亮色条 百分比
          {
            show: true,
            type: 'bar',
            barGap: '-100%',
            barWidth: '50%',
            barMaxWidth: 10,
            z: 2,
            itemStyle: {
              normal: {
                // barBorderRadius: 10,
                color: function(params) {
                  var num = myColor.length
                  return myColor[params.dataIndex % num]
                }
              }
            },
            label: {
              normal: {
                show: true,
                textStyle: {
                  color: '#000'
                },
                position: 'insideLeft',
                formatter: function(data) {
                  return (baifenbi[data.dataIndex] * 100).toFixed(1) + '%'
                }
              }
            },
            data: baifenbi
          },
          // 公司名称
          {
            show: true,
            type: 'bar',
            // xAxisIndex: 1, // 代表使用第二个X轴刻度
            barGap: '-100%',
            barWidth: '10%',
            itemStyle: {
              normal: {
                // barBorderRadius: 10,
                color: 'transparent'
              }
            },
            label: {
              normal: {
                show: true,
                position: [0, '-13'],
                textStyle: {
                  color: '#333'
                },
                formatter: function(data) {
                  return gs[data.dataIndex]
                }
              }
            },
            data: dataArr
          }
        ]
      }
      this.chart.setOption(option, true)
    }
  }
}
</script>
